// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"fc9d9085","669":"5b48ff48"}[chunkId] + ".chunk.css";
};